import { render, staticRenderFns } from "./Seminaires.vue?vue&type=template&id=5df3cb10&"
import script from "./Seminaires.vue?vue&type=script&lang=js&"
export * from "./Seminaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports